export enum ContractFields {
    NAME = 'name',
    CONDITIONS = 'conditions',
    SALARY_BASIS = 'salaryBasis',
    SALARY_PER_UNIT = 'salaryPerUnit',
    TRAVEL_EXPENSE_COMPENSATION_PER_KILOMETER = 'travelExpenseCompensationPerKilometer',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}
